import { useContext as o, createContext as n } from "react";
const r = /* @__PURE__ */ n(void 0);
function $(t) {
  const e = o(r);
  return t || e || "ltr";
}
export {
  $
};
